module.exports = __webpack_public_path__ + "static/media/iconfinder_NEGATIVE_devices_headphone_1287555.81c3d684.png";